import Link from 'next/link'
import { FaChevronRight } from 'react-icons/fa'
import { segment } from 'src/lib/Segments'

import OIIcon from '@components/icons'

const gems = [
  {
    icon: 'checkVerified' as const,
    title: 'Verified listings',
    description: 'Apartments with confirmed availability which you can apply to directly.',
    link: '/nyc/apartments-for-rent-nyc',
    iconColor: 'text-primary',
    bgColor: 'bg-purple-50',
    eventName: 'gems_verified_listings_card',
  },
  {
    icon: 'starOutline' as const,
    title: 'Units in top rated buildings',
    link: '/nyc/top-rated-listings',
    description:
      'Buildings that are highly reviewed and rated 4+ stars by past and current renters.',
    iconColor: 'text-yellow-400',
    bgColor: 'bg-yellow-50',
    eventName: 'gems_top_rated_buildings_card',
  },
  {
    icon: 'bankNote' as const,
    title: 'Rent-stabilized apartments',
    link: '/nyc/rent-stabilized-apartments',
    description: 'Apartments that entitle you to a renewal and limited rent increases.',
    iconColor: 'text-green-400',
    bgColor: 'bg-green-50',
    eventName: 'gems_rent_stabilized_apartments_card',
  },
]

const SpecialGems = () => {
  const handleGemClick = (gem) => {
    if (gem.eventName && segment?.[gem.eventName]) {
      segment[gem.eventName]()
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-dark-900">
        Special gems you just can't find anywhere else
      </h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {gems.map((gem) => (
          <Link href={gem.link} key={gem.title} passHref>
            <a
              className="md:flex-1 flex flex-row gap-3 rounded-2xl border border-light-40 bg-white p-4 md:min-w-0 md:flex-col md:gap-2"
              onClick={() => handleGemClick(gem)}
            >
              <div
                className={`h-10 w-10 flex-shrink-0 rounded-full ${gem.bgColor} flex items-center justify-center`}
              >
                <OIIcon
                  className={`${gem.iconColor}`}
                  name={gem.icon}
                  size="custom"
                  width={22}
                  height={22}
                />
              </div>
              <div className="flex-1 flex flex-col gap-2">
                <div className="flex items-center">
                  <h3 className="font-semibold text-dark-900">{gem.title}</h3>
                  <FaChevronRight size={9} className="ml-1 text-dark-900" />
                </div>
                <p className="text-sm text-dark-700">{gem.description}</p>
              </div>
            </a>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default SpecialGems
